module.exports = __webpack_public_path__ + "select.c5404ea0.png";